import React from "react";
import "./UserMenu.css";
import ProfileIcon from "../../assets/Icons/ProfileIcon.svg?react";
import GearIcon from "../../assets/Icons/GearIcon.svg?react";
import LogoutIcon from "../../assets/Icons/LogoutIcon.svg?react";

import { logout } from "../../containers/App/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Suggestions, { Suggestion } from "../Suggestions/Suggestions";

import User from "../../types/User";
import Avatar from "../Avatar/Avatar";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useTranslation } from "react-i18next";

type UserMenuProps = {
  user: User;
};
const UserMenu = ({ user }: UserMenuProps) => {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getAbsoluteRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const [isHidden, setIsHidden] = React.useState(true);
  const handleToggleIsHidden = () => {
    setIsHidden(x => !x);
  };

  const handleOutsideClick = React.useCallback(() => {
    setIsHidden(true);
  }, []);

  useOutsideClick(getAbsoluteRef, handleOutsideClick);

  const handlelogout = React.useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleRedirectUserProfile = React.useCallback(() => {
    navigate("/profile");
  }, [navigate]);

  const handleRedirectSettings = React.useCallback(() => {
    navigate("/settings");
  }, [navigate]);

  const handleRedirectUsers = React.useCallback(() => {
    navigate("/users");
  }, [navigate]);

  const userMenuItems = React.useMemo<Array<Suggestion>>(() => {
    const menuItems: Array<Suggestion> = [
      {
        id: 1,
        label: t("profile"),
        icon: <ProfileIcon />,
        onClick: handleRedirectUserProfile,
      },
      {
        id: 2,
        label: t("settings"),
        icon: <GearIcon />,
        onClick: handleRedirectSettings,
      },
      {
        id: 3,
        label: t("logout"),
        icon: <LogoutIcon />,
        onClick: handlelogout,
      },
    ];
    if (user.isAdmin) {
      menuItems.push({
        id: 4,
        label: t("users"),
        icon: <ProfileIcon />,
        onClick: handleRedirectUsers,
      });
    }
    return menuItems;
  }, [
    handleRedirectUserProfile,
    handleRedirectSettings,
    handlelogout,
    handleRedirectUsers,
    user,
    t,
  ]);

  return (
    <div
      className="UserMenu"
      ref={getAbsoluteRef}
      onClick={handleToggleIsHidden}
    >
      <Avatar user={user} />
      {!isHidden && (
        <Suggestions
          className="UserMenu__Suggestions"
          suggestions={userMenuItems}
        />
      )}
    </div>
  );
};

export default UserMenu;
